import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import TransactionRow from '../transactionrow';
// import './style.css';

const MonthTransactionBlock = (props) => {
  const getMonthName = (i) => {
    const months = moment.months();
    return `${months[parseInt(i, 10) - 1]}`;
  };
  return (
    <div className="month_block">
      <div className="month_name">
        <div className="month_name_text">
          {/* <FormattedMessage id={getMonthName(Object.keys(props.data)[0])} /> */}
          <span>{getMonthName(moment(props.data[0].transaction_date).month() + 1)}</span>
        </div>
      </div>
      {Object.keys(props.data).map(item => <TransactionRow key={`'trow-${Math.random(15000)}'`} transaction={props.data[item]} user={props.user} customerID={props.customerID}/>)}
    </div>
  );
};

MonthTransactionBlock.propTypes = {
  data: PropTypes.shape([]).isRequired,
  user: PropTypes.shape([]).isRequired,
};

export default MonthTransactionBlock;
